/**
 * Environment detection only — deliberately free of `xumm`, `currencies.json` and
 * the XRPL helpers so modules on the critical path (persistent-store) can ask
 * "are we in an xApp?" without pulling that graph into the shared bundle.
 */

let detected = false;

/** Called by xaman-xapp once the Xumm runtime confirms we are inside an xApp. */
export const markXamanXappDetected = () => {
  detected = true;
};

/**
 * The `xAppToken` query param only exists on the entry URL, so detection is
 * sticky: once true it stays true for the rest of the session.
 */
export const isXamanXappEnvironment = () => {
  if (typeof window === 'undefined') return false;
  if (detected) return true;

  try {
    if (new URLSearchParams(window.location.search).has('xAppToken')) {
      detected = true;
    }
  } catch {
    return false;
  }

  return detected;
};

/** Test helper — clears sticky detection. */
export const resetXamanXappDetection = () => {
  detected = false;
};
